module.exports = __webpack_public_path__ + "static/img/video.d6de363f.svg";